import { render, staticRenderFns } from "./ProfileAdd.vue?vue&type=template&id=0207c276&"
import script from "./ProfileAdd.vue?vue&type=script&lang=js&"
export * from "./ProfileAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports